var React = require('react');

function StarLargeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.9998 23.0266L24.2398 28L22.0532 18.6266L29.3332 12.32L19.7465 11.5066L15.9998 2.66663L12.2532 11.5066L2.6665 12.32L9.9465 18.6266L7.75984 28L15.9998 23.0266Z","fill":"#323232"}));
}

StarLargeInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = StarLargeInline;

StarLargeInline.default = StarLargeInline;
